
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_25104","data-name":"Group 25104","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.922 14.361"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19925","data-name":"Path 19925","d":"M9.938 8a1.938 1.938 0 101.938 1.938A1.938 1.938 0 009.938 8zm0 2.907a.969.969 0 11.969-.969.969.969 0 01-.969.969z","transform":"translate(-3.477 -2.758)","fill":"#5c8df5"}}),_c('path',{attrs:{"id":"Path_19926","data-name":"Path 19926","d":"M13.225 8.317l-.266-.153a5.445 5.445 0 000-1.969l.266-.153a1.8 1.8 0 10-1.8-3.112l-.266.154a5.372 5.372 0 00-1.7-.983V1.8a1.8 1.8 0 00-3.59 0v.3a5.372 5.372 0 00-1.7.985L3.9 2.932a1.8 1.8 0 10-1.8 3.112l.266.153a5.445 5.445 0 000 1.969l-.266.153a1.8 1.8 0 001.8 3.111l.266-.154a5.372 5.372 0 001.705.983v.307a1.8 1.8 0 003.59 0v-.307a5.372 5.372 0 001.7-.985l.267.154a1.8 1.8 0 101.8-3.112zM11.7 6.058a4.217 4.217 0 010 2.244.6.6 0 00.278.678l.649.375a.6.6 0 11-.6 1.037l-.65-.376a.6.6 0 00-.727.1 4.179 4.179 0 01-1.941 1.122.6.6 0 00-.449.58v.75a.6.6 0 11-1.2 0v-.749a.6.6 0 00-.449-.58 4.179 4.179 0 01-1.94-1.124.6.6 0 00-.727-.1l-.649.375a.6.6 0 11-.6-1.036l.649-.375a.6.6 0 00.284-.679 4.217 4.217 0 010-2.244.6.6 0 00-.278-.676l-.65-.374a.6.6 0 01.6-1.037l.65.376a.6.6 0 00.726-.1 4.179 4.179 0 011.94-1.118.6.6 0 00.449-.582V1.8a.6.6 0 111.2 0v.749a.6.6 0 00.449.58 4.179 4.179 0 011.941 1.124.6.6 0 00.727.1l.649-.375a.6.6 0 11.6 1.036l-.649.375a.6.6 0 00-.277.676z","transform":"translate(-1.203)","fill":"#5c8df5"}})])
          )
        }
      }
    